import React from "react";
import { Link, NavLink } from "react-router-dom";
import "./AdminSidebar.css";


export default function AdminSidebar({ isOpen, toggleSidebar }) {


  const menuItems = [
    { name: "Dashboard", path: "/admin/dashboard", icon: "dashboard" },
     { name: "Landingpage", path: "/admin/homemange", icon: "web" },
    { name: "Blogs", path: "/admin/blog", icon: "article" },
    { name: "Coupons", path: "/admin/coupon", icon: "confirmation_number" },
     { name: "Category", path: "/admin/Categories", icon: "category" },
    { name: "Orders", path: "/admin/orders", icon: "shopping_cart" },
    { name: "Product", path: "/admin/productlist", icon: "inventory_2" },
     { name: "Gallery", path: "/admin/gallery", icon: "photo_library" },
    { name: "Settings", path: "/admin/settings", icon: "settings" },
  ];

  return (
    <>
    



      <aside className={`admin-sidebar ${isOpen ? "open" : "closed"}`}>
        
    
        <div className="sidebar-brand">
          <Link to="/"><h2 className="brand-name">∐ RBUYMART</h2></Link>
                <button 
        onClick={toggleSidebar} 
        className="mobile-toggle-btn"
        aria-label="Toggle Sidebar"
      >
        {isOpen ? "❮" : "❯"}
      
      </button>
    
     
        
        </div>

       
        <nav className="sidebar-nav">
                <div className="search-input">
  <i class="material-icons">&#xe8b6;</i>
   <input
            type="search"
            placeholder="Search..."
            
          
            
          />
</div>
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => 
                `menu-item-title ${isActive ? "active-link" : ""}`
              }
            >
              {/* Unicode आइकॉन रेंडर */}
              <span className="nav-icon"><i className="material-icons">{item.icon}</i></span>
              <span className="nav-text">{item.name}</span>
            </NavLink>
          ))}
        </nav>

   
        <div className="sidebar-footer">
          <div className="profile-avatar">RB</div>
          <div className="profile-info">
            <span className="profile-name">Admin Dashboard</span>
            <span className="profile-email">admin@rbuymart.com</span>
          </div>
        </div>
      </aside>

   
      {isOpen && <div onClick={toggleSidebar} className="sidebar-overlay" />}

      <div className="admin-nav-div">
        <div className="flex-div">
<Link to="/"><button className="btn-view"><i className="material-icons">&#xe417;</i></button></Link>
  <button className="btn-logout"><i class="material-icons">&#xe879;</i> Logout </button>
        </div>
       
      </div>
    </>
  );
}